<template>
  <div>
    <div class="w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px">
      <router-link :to="{ name: 'Home' }">
        <svg-filler class="mg-r-auto f-left cs-pointer" path="/static/svg/back.svg" :fill="'#ffffff'" width="20px" height="20px"/>
      </router-link>
      <span>
        มีสินค้าในตระกร้าจำนวน {{amount}} ชิ้น
      </span>
    </div>
    <div class="columns is-marginless is-centered">
      <div class="list-item column is-6 is-marginless pd-20px">
        <div class="columns is-marginless is-paddingless">
          <list-cart :items="items" @removeItem="remove"></list-cart>
        </div>
        <div class="columns is-marginless is-paddingless f-left w-100pct">
          <div class="column is-6 is-offset-3">
            <div @click="clear()" class="mg-auto clear-item mg-hrzt-auto cl-white f-w-bold pd-6px cs-pointer">ล้างรายการ</div>
          </div>
        </div>
      </div>
    </div>
    <div class="cart-data columns is-marginless is-centered">
      <div class="column is-6 is-marginless pd-20px">
        <div class="f-s-16px f-w-bold t-al-left">
          เบอร์โทรศัพท์
        </div>
        <div v-if="!isTel">
          <VueTelInput v-model="tel"
            @onInput="onInputTel"
            :preferredCountries="['us', 'gb', 'ua', 'th']"
            class="input-data f-left pd-6px w-100pct"/>
        </div>
        <div v-else>
          <VueTelInput v-model="tel"
            :disabled="true"
            class="input-data f-left pd-6px"/>
          <div class="f-left search pd-6px cs-pointer cl-light f-w-bold" @click="changTel()">
            Clear
          </div>
        </div>
        
        <br>
        <br>

        <div class="f-s-16px f-w-bold t-al-left">
          รหัสส่วนลดพิเศษ 
        </div>
        <div  v-if="!isCode">
          <input placeholder="GW-1234" v-model="promoCode" class="input-data f-left pd-6px">
          <div class="f-left search pd-6px cs-pointer" @click="verifyCode()">
            <svg-filler path="/static/svg/search.svg" :fill="'#ffffff'" width="20px" height="20px"/>
          </div>
        </div>
        <div v-else>
          <input placeholder="GW-1234" v-model="promoCode" disabled="disabled" class="input-data f-left pd-6px">
          <div class="f-left search pd-6px cs-pointer cl-light f-w-bold" @click="changCode()">
            Clear
          </div>
        </div>
        <br>
        <br>
        <div class="dp-flex jtf-ct-space-between f-s-16px f-w-bold">
          <div class="w-50pct t-al-left">
            ราคารวม
          </div>
          <div class="w-50pct t-al-right">
            ฿ {{ getFullPrice | showFullPriceFormat() }}
          </div>
        </div>
        <div class="dp-flex jtf-ct-space-between f-s-16px f-w-bold">
          <div class="w-50pct t-al-left">
            ส่วนลดรวม
          </div>
          <div class="w-50pct t-al-right">
            ฿ <span v-if="(getFullPrice - undiscountPrice) > 0">-</span>{{ getFullPrice - undiscountPrice | showFullPriceFormat() }}
          </div>
        </div>
        <div class="dp-flex jtf-ct-space-between f-s-16px f-w-bold">
          <div class="w-80pct t-al-left">
            ส่วนลดพิเศษ
            <span class="f-s-13px" v-if="promotionCodeDetails.discountType === 'amount'">ลด ฿ {{ promotionCodeDetails.discountNumber | showFullPriceFormat() }}</span>
            <span class="f-s-13px" v-else-if="promotionCodeDetails.discountType === 'percent'">ลด {{ promotionCodeDetails.discountNumber | showFullPriceFormat() }} % </span>
          </div>
          <div class="w-50pct t-al-right">
            ฿ <span v-if="discount > 0">-</span>{{ discount | showFullPriceFormat() }}
          </div>
        </div>
        <div class="dp-flex jtf-ct-space-between f-s-16px f-w-bold">
          <div class="w-50pct t-al-left">
            ราคาสุทธิ
          </div>
          <div class="w-50pct t-al-right">
            ฿ {{ netPrice | showFullPriceFormat() }}
          </div>
        </div>
        <div class="dp-flex jtf-ct-space-between f-w-bold">
          <div class="add-item-btn cs-pointer" @click="$router.push({ name: 'ScanToSearch' })">
            + เพิ่มสินค้า
          </div>
          <div class="checkout-btn cs-pointer" @click="confirm()">
            ชำระเงิน ({{netPrice | showFullPriceFormat()}} ฿)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ListCart from './ListCart'
import VueTelInput from 'vue-tel-input'

export default {
  name: 'cart',
  data () {
    return {
      tel: '',
      promoCode: '',
      phone: {},
      isTel: false,
      isCode: false,
      isReady: false
    }
  },
  components: {
    ListCart,
    VueTelInput
  },
  methods: {
    ...mapActions([
      'clearAllData',
      'verifyPromoCode',
      'clearDiscount',
      'setTel',
      'setIsloading',
      'removeItem',
      'fetchPrinters'
    ]),
    onInputTel ({ number, isValid, country }) {
      this.phone = {
        number: number.replace(/ /g, ''),
        isValid,
        country
      }
    },
    remove (item) {
      this.$dialog.confirm({
        title: 'ลบสินค้าออกจากตระกร้า',
        message: 'คุณแน่ใจแล้วใช่ไหมที่จะ<span class="error-message">ลบสินค้าชิ้นนี้</span>ออกจากตระกร้า?',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: () => {
          this.promoCode = ''
          this.isCode = false
          this.clearDiscount()
          this.removeItem(item)
        }
      })
    },
    clear () {
      this.$dialog.confirm({
        title: 'ลบสินค้าทุกชิ้นออกจากตระกร้า',
        message: 'คุณแน่ใจแล้วใช่ไหมที่จะ<span class="error-message">ลบสินค้าทุกชิ้น</span>ออกจากตระกร้า?',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: () => {
          this.clearAllData()
          this.$router.push({ name: 'Home' })
        }
      })
    },
    async verifyCode () {
      const validTel = this.setMemberTel()
      if (!validTel) {
        return
      }
      this.setIsloading(true)
      let message = ''
      let params = {
        promoCode: this.promoCode.toUpperCase(),
        tel: this.getTel,
        getFullPrice: this.getFullPrice
      }
      const res = await this.verifyPromoCode(params)
      if (res.data.success) {
        message = `<center>Code <span class="success-message">${res.data.promotion_code.code}</span> can be use.</center>`
        this.isCode = true
      } else {
        message = `<center><span class="error-message">${res.data.error.message}</center>`
      }
      this.setIsloading(false)
      this.$dialog.alert({
        confirmText: 'ตกลง',
        title: res.title,
        message
      })
    },
    setMemberTel () {
      const tel = this.tel.replace(/ /g, '')
      if (this.phone.isValid) {
        this.setTel(tel)
        this.isTel = true
        return true
      } else {
        this.$dialog.alert({
          confirmText: 'ตกลง',
          title: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
          message: 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'
        })
        return false
      }
    },
    confirm () {
      if (this.tel !== '') {
        const isTel = this.setMemberTel()
        if (isTel) {
          this.$router.push({ name: 'Payment' })
        }
      } else {
        this.$router.push({ name: 'Payment' })
      }
    },
    changTel () {
      this.isTel = false
      this.phone = {}
      this.isCode = false
      this.tel = ''
      this.promoCode = ''
      this.clearDiscount()
      this.setTel()
    },
    changCode () {
      this.isCode = false
      this.clearDiscount()
    }
  },
  computed: {
    ...mapGetters({
      netPrice: 'getNetPrice',
      discount: 'discount',
      undiscountPrice: 'getUndiscountPrice',
      amount: 'getItemsAmount',
      promotionCodeDetails: 'promotionCodeDetail',
      items: 'getItems',
      stepPricing: 'getStepPricing',
      getTel: 'getTel',
      promotionCode: 'promotionCodeDetail',
      getFullPrice: 'getFullPrice'
    })
  },
  async mounted () {
    let toastAlert = []
    this.items.forEach(item => {
      if (!this.stepPricing[parseInt(item.price)] && (toastAlert.findIndex(name => name === item.name) === -1)) {
        toastAlert.push(item.name)
      }
    })
    toastAlert.forEach(item => {
      this.$toast.open({
        type: 'is-warning',
        message: `<strong>${item}</strong> สินค้าชิ้นนี้ไม่อยู่ใน Step Pricing.`,
        position: 'is-top-right',
        duration: '5000',
        queue: false
      })
    })
    if (this.getTel !== '') {
      this.phone.isValid = true
      this.tel = this.getTel
      this.isTel = true
    }
    if (this.promotionCode.code && this.promotionCode.code !== '') {
      this.promoCode = this.promotionCode.code
      this.isCode = true
    } else {
      this.isCode = false
      this.clearDiscount()
    }
    await this.fetchPrinters()
  },
  watch: {
    amount (val) {
      if (val === 0) {
        this.$router.push({ name: 'Home' })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear-item {
  font-size: 0.75rem;
  width: 160px;
  height: 36px;
  border-radius: 4px;
  background-color: #f83c3c;
  border: solid 1px #e5e5e5;
}
.input-data {
  width: 75%;
  height: 36px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #000000;
}
.list-item {
  overflow: auto;
  height: calc(100vh - 360px);
}
.search {
  width: 25%;
  height: 36px;
  /* border-radius: 2px; */
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #000000;
}
.cart-data {
  height: 300px;
  background-color: #f2f2f2;
}
.add-item-btn {
  font-size: 0.75rem;
  color: #ffffff;
  padding: 0.6rem;
  width: 30%;
  height: 36px;
  border-radius: 4px;
  background-color: #000000;
}

.checkout-btn {
  height: 36px;
  width: 65%;
  color: #ffffff;
  font-size: 0.75rem;
  padding: 0.6rem;
  float: left;
  margin-left: 16px;
  border-radius: 4px;
  background-color: #27cf5a;
}
.summary-price {
  text-align: right;
  border-bottom: 1px solid #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// src/views/cart/Cart.vue